import PropTypes from 'prop-types';

import { ElectionWeekCalendarGrid } from './ElectionWeekCalendarGrid';
import { ElectionWeekCalendarHeader } from './ElectionWeekCalendarHeader';

export function ElectionWeekCalendarWeek({ week, slots }) {
  return (
    <section id={week.key} className="relative border-b border-stone-200 last:border-b-0">
      <ElectionWeekCalendarHeader week={week} />
      <ElectionWeekCalendarGrid week={week} slots={slots} />
    </section>
  );
}

ElectionWeekCalendarWeek.propTypes = {
  week: PropTypes.shape({
    key: PropTypes.string.isRequired,
    days: PropTypes.arrayOf(PropTypes.object).isRequired,
    weekLabel: PropTypes.string.isRequired,
  }).isRequired,
  slots: PropTypes.arrayOf(PropTypes.object).isRequired,
};
